import React, { Fragment } from 'react';

import useTrapFocus from 'Hooks/useTrapFocus';

import { IContentLinkModel } from 'Types/Litium';
import Markup from 'Components/Markup';

interface MegaMenuDropDownProps {
    data: IContentLinkModel[];
    showMenu: boolean;
    menuId: string;
    setShowMenuIndex: React.Dispatch<React.SetStateAction<number>>;
}

const MegaMenuDropDown = ({
    data,
    menuId,
    showMenu,
    setShowMenuIndex,
}: MegaMenuDropDownProps) => {
    const closeTrap = () => {
        setShowMenuIndex(-1);
    };
    const trapRef = useTrapFocus(showMenu, closeTrap);
    return (
        <div
            id={menuId}
            style={
                {
                    '--page-margin': '56px',
                } as React.CSSProperties
            }
            className={`${
                showMenu ? 'visible opacity-100' : 'invisible opacity-0'
            }  scroll-bar-gsd-thin::-webkit-scrollbar scroll-bar-gsd-thin::-webkit-scrollbar-thumb scroll-bar-gsd-thin absolute left-0
      top-full -z-[1] mx-14 min-w-[var(--mega-menu-width)] max-w-[calc(100dvw_-_(var(--page-margin)_+_var(--page-margin)))] bg-lightMerino px-6 transition-[visibility,_opacity] duration-layout ease-in-out lg:z-20 lg:before:relative lg:before:-top-5 lg:before:block lg:before:h-5 lg:before:w-full lg:before:shadow-minimal xl:-z-[1] xl:mt-0 xl:px-14 xl:before:content-none`}
        >
            <div className="relative w-full overflow-x-auto">
                <ul ref={trapRef} className="my-0 flex gap-[41px] pb-6 pt-4">
                    {data.map((subItem, subIndex) => (
                        <Fragment key={subIndex}>
                            {(subItem.links?.[0]?.name?.length > 0 ||
                                subItem.links.length > 0) && (
                                <li className="relative flex-1 after:absolute after:-right-[21px] after:top-0 after:block after:h-full after:w-px after:bg-gradient-to-b after:from-transparent after:via-sonicSilver after:to-transparent last:after:content-none">
                                    {!subItem.links?.[0]?.url &&
                                    subItem.links?.[0]?.name?.length > 0 ? (
                                        <Markup
                                            html={subItem.links?.[0]?.name}
                                            cssClass="prose-img:m-0 prose:m-0"
                                        />
                                    ) : (
                                        subItem.links.length > 0 && (
                                            <>
                                                <h2 className="mb-3.5 text-nowrap pt-1 font-montserrat text-base font-normal leading-4 text-black">
                                                    {subItem.name}
                                                </h2>
                                                <ul
                                                    role="menu"
                                                    style={
                                                        {
                                                            '--rows':
                                                                subItem.links
                                                                    .length >= 9
                                                                    ? 9
                                                                    : subItem
                                                                          .links
                                                                          .length,
                                                            '--columns':
                                                                Math.ceil(
                                                                    subItem
                                                                        .links
                                                                        .length /
                                                                        9
                                                                ),
                                                        } as React.CSSProperties
                                                    }
                                                    className="grid grid-flow-col grid-cols-[repeat(var(--columns)_,_minmax(min-content,_auto))] grid-rows-[repeat(var(--rows),_minmax(0,_1fr))] gap-4"
                                                >
                                                    {subItem.links.map(
                                                        (
                                                            menuLink,
                                                            menuLinkIndex
                                                        ) => (
                                                            <li
                                                                key={
                                                                    menuLinkIndex
                                                                }
                                                            >
                                                                <a
                                                                    role="menuitem"
                                                                    className="flex items-center font-roboto text-sm font-normal text-black hover:underline"
                                                                    href={
                                                                        menuLink.url
                                                                    }
                                                                >
                                                                    <span className="whitespace-nowrap">
                                                                        {
                                                                            menuLink.name
                                                                        }
                                                                    </span>
                                                                </a>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </>
                                        )
                                    )}
                                </li>
                            )}
                        </Fragment>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default MegaMenuDropDown;
